import { render, staticRenderFns } from "./MonitorarVirtual.vue?vue&type=template&id=15da4642&scoped=true"
import script from "./MonitorarVirtual.vue?vue&type=script&lang=js"
export * from "./MonitorarVirtual.vue?vue&type=script&lang=js"
import style0 from "./MonitorarVirtual.vue?vue&type=style&index=0&id=15da4642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da4642",
  null
  
)

export default component.exports